
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/treasure-trail",
      function () {
        return require("private-next-pages/games/treasure-trail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/treasure-trail"])
      });
    }
  